import React from "react";
import { Drawer } from "@mui/material";
import PolicyHistoryDrawerContent from "./PolicyHistoryDrawerContent";
import CTReviewsDrawerContent from "./CTReviewsDrawerContent";
import AdoptionDetailsDrawerContent from "./AdoptionDetailsDrawerContent";
import { useDispatch } from "react-redux";
import { setDialog } from "slices/appSlice";

const Drawers = ({
  activeDrawer,
  closeDrawer,
  healthPlanKey,
  policyKey,
  policyVersion,
  status,
  lobAdoptionDecisions,
  policyHistoryData,
  setPolicyHistoryData,
  ctReviewData,
  reviewData,
  setReviewData,
  editable,
  ctReviewEditable = true,
}) => {
  const dispatch = useDispatch();

  const ctReviewRows = Array.isArray(ctReviewData) ? ctReviewData : [];

  const handleCloseDrawer = () => {
    // Guard in case reviewData is undefined or comments missing
    const results = reviewData?.results;
    const comments = (reviewData?.comments ?? "").trim();

    if (
      activeDrawer === "ctReviews" &&
      ctReviewEditable &&
      results === "fail" &&
      !comments
    ) {
      dispatch(
        setDialog({ message: "Comments are required when selecting 'Fail'" })
      );
      return;
    }

    closeDrawer(); // Only close the drawer if validation passes
  };

  const commonDrawerProps = {
    open: Boolean(activeDrawer),
    onClose: handleCloseDrawer,
    anchor: "right",
    sx: {
      width: "50vw",
      "& .MuiDrawer-paper": { width: "50vw", top: "50px" },
    },
  };

  return (
    <>
      {activeDrawer === "adoptionDetails" && (
        <Drawer {...commonDrawerProps}>
          <AdoptionDetailsDrawerContent
            lobAdoptionDecisions={lobAdoptionDecisions}
            closeDrawer={closeDrawer}
          />
        </Drawer>
      )}

      {activeDrawer === "ctReviews" && (
        <Drawer {...commonDrawerProps}>
          <CTReviewsDrawerContent
            policyKey={policyKey}
            healthPlanKey={healthPlanKey}
            closeDrawer={closeDrawer}
            ctReviewRows={ctReviewRows}
            reviewData={reviewData}
            setReviewData={setReviewData}
            editable={ctReviewEditable}
          />
        </Drawer>
      )}

      {activeDrawer === "policyHistory" && (
        <Drawer {...commonDrawerProps}>
          <PolicyHistoryDrawerContent
            editable={editable}
            policyVersion={policyVersion}
            policyKey={policyKey}
            closeDrawer={closeDrawer}
            policyHistoryData={policyHistoryData}
            setPolicyHistoryData={setPolicyHistoryData}
          />
        </Drawer>
      )}
    </>
  );
};

export default Drawers;
